// extracted by mini-css-extract-plugin
export default {"main":"Industrial_main__jgFcd"};